import React from "react";

import { PartnerFilterStep, selectActiveStep } from "modules/customer/tools/product/partnerFilters/partnerFiltersSlice";
import { useAppSelector } from "store";
import PartnerFascias from "./partnerFascias/PartnerFascias";
import OperatorFascias from "./operatorFascias/OperatorFascias";

const Content: React.FC = () => {
    const activeStep = useAppSelector(selectActiveStep);

    return (
        <>
            {activeStep === PartnerFilterStep.SelectPartner && (<PartnerFascias />)}
            {activeStep === PartnerFilterStep.SelectOperator && (<OperatorFascias />)}
        </>
    );
};

export default Content;
